<template>
  <div v-if="surveys.length">
    <div v-for="survey in surveys" :key="survey.uuid" class="mb-4">
      <div class="font-bold mb-2">{{ survey.question }}</div>
      <div v-if="survey.options && survey.options.length">
        <ul class="ml-4">
          <li v-for="option in survey.options" :key="option.uuid">
            {{ option.option }}
          </li>
        </ul>
      </div>
      <div v-else class="ml-4 text-gray-500">Aucune réponse disponible</div>
    </div>
  </div>
  <div v-else class="text-gray-500">Aucun sondage dans ce groupe</div>
</template>

<script>
export default {
  name: 'MVPMediaDetailRenderer',
  computed: {
    surveys () {
      return this.params && this.params.data && Array.isArray(this.params.data.surveys)
        ? this.params.data.surveys
        : []
    }
  }
}
</script>

<style scoped>
ul {
  list-style-type: disc;
}
</style>
